import axios from 'axios';

// 携带cookie
axios.defaults.withCredentials = true;


const isLocal = process.env.NODE_ENV === 'development';

// 先使用local 后期确定好测试服务器后配置测试&线上
const baseUrl:string = isLocal ? '//192.168.0.176:8088' : '';
export default baseUrl;
